import { Box, Button, Stack, Typography } from '@mui/material'
import { IBizzaboSectionData, IPrice } from '../../interface'
import EducationMetadataBlock from './EducationMetadataBlock'
import { convertToSlug } from 'src/utils'
import { FormattedMessage } from 'react-intl'
import { IntlLink } from '../Common/IntlComponents'

interface IBizzaboAccordionContent {
  data: IPrice
  dates: string[]
  sectionData: IBizzaboSectionData[]
}

const BizzaboAccordionContent = ({ data, dates, sectionData }: IBizzaboAccordionContent) => {
  const { unit_amount, productName, metadata } = data

  const PriceDescription = () => {
    return (
      <>
        {sectionData.map((section, index) => (
          <Typography key={index}>
            {metadata._sku === section.sku && <FormattedMessage id={section.descriptionId} />}
          </Typography>
        ))}
      </>
    )
  }

  return (
    <Box data-gtm-click-subsection1={metadata._version}>
      <PriceDescription />
      <Stack sx={{ marginY: 3, gap: 1 }}>
        <EducationMetadataBlock title='education.metadata.skillLevel' data={metadata['Skill Level'].values} />
        <EducationMetadataBlock title='education.metadata.dates' data={dates} />
        <EducationMetadataBlock title='education.metadata.location' data={metadata['Location'].values} />
        <EducationMetadataBlock title='education.metadata.price' data={unit_amount} />
      </Stack>
      {productName && (
        <Button
          data-gtm-click-subsection2='primary-cta'
          component={IntlLink}
          to={`/store/${convertToSlug(productName)}/${convertToSlug(metadata._version)}`}
          variant='contained'
        >
          <FormattedMessage id='common.buyNow' />
        </Button>
      )}
    </Box>
  )
}

export default BizzaboAccordionContent
